// extracted by mini-css-extract-plugin
module.exports =  {"select":"CAk8kto1aqoKyWCyNVnF"};